(function ($) {
    $(function () {
        $('.simplemde-editor').each(function () {
            var $input = $(this);

            new SimpleMDE({
                element: $input[0],
                autoDownloadFontAwesome: false,
                spellChecker: false,
                toolbar: ['bold', 'italic', 'strikethrough', '|', 'heading-1', 'heading-2', 'heading-3', '|', 'code', 'quote', 'clean-block', '|', 'unordered-list', 'ordered-list', '|', 'link', 'image', '|', 'preview']
            });
        });
    });
})(jQuery);
